import PropTypes from 'prop-types';

import * as Styled from './Input.styles';



export const Input = ({ onChange, onKeyDown, label, value, error, className, onFocus, onBlur, disabled,type }) => {
  return (
    <Styled.TextField
      label={label}
      variant="outlined"
      value={value}
      error={!!error}
      helperText={error}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      className={className}
      type={type}
      disabled={disabled}
      fullWidth
    />
  );
};

Input.propTypes = {
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
